// extracted by mini-css-extract-plugin
export var ball1 = "g_L";
export var ball2 = "g_M";
export var bounce = "g_K";
export var fullscreen = "g_H";
export var spinner = "g_J";